import { TUTORIALS_ENABLED } from "./config.js";

export const ONBOARDING_KEY = "welcome_onboarding";
export const WELCOME_PROGRESS_EVENT = "markezy:welcome-progress";

export function refreshWelcomeProgress() {
  window.dispatchEvent(new CustomEvent(WELCOME_PROGRESS_EVENT));
}

export const isWelcomeEligible = (user) =>
  TUTORIALS_ENABLED &&
  user?.role === "agency_admin" &&
  user?.agencyPlan?.is_trial &&
  !user?.ui_preferences?.commercial_tour_completed &&
  !user?.ui_preferences?.[ONBOARDING_KEY]?.completed_at;

// Bienvenida, puerta del cliente y recorrido del menú; la guía "Primeros pasos" no cuenta
export const isWelcomeTourPending = (user) =>
  isWelcomeEligible(user) && !user?.ui_preferences?.[ONBOARDING_KEY]?.sidebar_tour_completed_at;
